(function () {
  // 简单区号列表（可按需扩展）
  var AREA_OPTIONS = [
    { code: 'US', dialCode: '+1' },
    { code: 'SG', dialCode: '+65' },
    { code: 'CN', dialCode: '+86' },
    { code: 'GB', dialCode: '+44' }
  ];

  function getCountryDisplayLocale() {
    var rawLocale = String(
      (window.Shopify && window.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      'en'
    ).trim();
    var lowerLocale = rawLocale.toLowerCase();

    if (lowerLocale === 'zh-cn') return 'zh-CN';
    if (lowerLocale === 'zh-tw') return 'zh-TW';
    if (lowerLocale.indexOf('zh') === 0) return lowerLocale.indexOf('tw') !== -1 ? 'zh-TW' : 'zh-CN';
    if (lowerLocale.indexOf('de') === 0) return 'de';
    if (lowerLocale.indexOf('fr') === 0) return 'fr';
    if (lowerLocale.indexOf('it') === 0) return 'it';
    if (lowerLocale.indexOf('nl') === 0) return 'nl';
    if (lowerLocale.indexOf('es') === 0) return 'es';
    if (lowerLocale.indexOf('ja') === 0) return 'ja';
    if (lowerLocale.indexOf('ko') === 0) return 'ko';
    if (lowerLocale.indexOf('th') === 0) return 'th';
    return 'en';
  }

  function getCountryFlag(countryCode) {
    var normalizedCode = String(countryCode || 'US').toUpperCase();
    if (normalizedCode.length !== 2) return '🇺🇸';
    try {
      var codePoints = normalizedCode.split('').map(function (char) {
        return 127397 + char.charCodeAt(0);
      });
      return String.fromCodePoint.apply(String, codePoints);
    } catch (error) {
      return '🇺🇸';
    }
  }

  function getLocalizedCountryName(countryCode) {
    var normalizedCode = String(countryCode || '').toUpperCase();
    var locale = getCountryDisplayLocale();
    if (window.CountryDisplayUtils && typeof window.CountryDisplayUtils.getLocalizedCountryName === 'function') {
      return window.CountryDisplayUtils.getLocalizedCountryName(normalizedCode, locale, normalizedCode || 'US');
    }

    var specialNames = {
      HK: { en: 'Hong Kong (China)', 'zh-CN': '中国香港', 'zh-TW': '中國香港' },
      TW: { en: 'Taiwan (China)', 'zh-CN': '中国台湾', 'zh-TW': '中國台灣' },
      MO: { en: 'Macao (China)', 'zh-CN': '中国澳门', 'zh-TW': '中國澳門' }
    };

    if (specialNames[normalizedCode]) {
      return specialNames[normalizedCode][locale] || specialNames[normalizedCode].en || normalizedCode;
    }

    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      try {
        var displayNames = new Intl.DisplayNames([locale, 'en'], { type: 'region' });
        var localizedName = displayNames.of(normalizedCode);
        if (localizedName && localizedName !== normalizedCode) {
          return localizedName;
        }
      } catch (error) {}
    }

    return normalizedCode || 'US';
  }

  function getAreaOptionLabel(option) {
    return getLocalizedCountryName(option.code) + ' ' + option.dialCode;
  }

  function getAreaOptionByCode(countryCode) {
    var normalizedCode = String(countryCode || '').toUpperCase();
    for (var i = 0; i < AREA_OPTIONS.length; i++) {
      if (AREA_OPTIONS[i].code === normalizedCode) {
        return AREA_OPTIONS[i];
      }
    }
    return null;
  }

  function getSelectedDialCode(root) {
    var codeEl = root.querySelector('.component-phone-input__country-code');
    if (!codeEl) return '+1';
    var txt = (codeEl.textContent || '').trim();
    return txt || '+1';
  }

  // 按区号做简单长度校验：统一使用 7~15 位校验
  function validatePhoneByDialCode(dialCode, raw) {
    var digits = (raw || '').replace(/\D/g, '');
    var code = (dialCode || '').replace('+', '');

    if (!digits) {
      return {
        isValid: false,
        message: 'Please enter a correct phone number'
      };
    }

    var min = 7;
    var max = 15;

    var ok = digits.length >= min && digits.length <= max;
    return {
      isValid: ok,
      message: ok ? '' : 'Please enter a correct phone number'
    };
  }

  function buildAreaList(listEl, defaultDial, searchQuery) {
    if (!listEl) return;
    listEl.innerHTML = '';

    var query = String(searchQuery || '').trim().toLowerCase();

    AREA_OPTIONS.filter(function (opt) {
      if (!query) return true;
      return getAreaOptionLabel(opt).toLowerCase().indexOf(query) !== -1 ||
        String(opt.dialCode || '').toLowerCase().indexOf(query) !== -1;
    }).forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'component-phone-input__country-item';
      btn.setAttribute('data-dial-code', opt.dialCode);
      btn.setAttribute('data-country', opt.code);
      btn.textContent = getAreaOptionLabel(opt);

      if (opt.dialCode === defaultDial) {
        btn.classList.add('is-selected');
      }

      listEl.appendChild(btn);
    });
  }

  function initPhoneInput(root) {
    if (!root || root.getAttribute('data-initialized') === 'true') return;
    root.setAttribute('data-initialized', 'true');

    var countryBtn = root.querySelector('.component-phone-input__country-btn');
    var dropdown = root.querySelector('.component-phone-input__country-dropdown');
    var list = root.querySelector('.component-phone-input__country-list');
    var searchInput = root.querySelector('.component-phone-input__search-input');
    var flagSpan = root.querySelector('.component-phone-input__country-flag');
    var codeSpan = root.querySelector('.component-phone-input__country-code');
    var input = root.querySelector('.component-phone-input__field');
    var errorEl = root.querySelector('.component-phone-input__error');
    var clearBtn = root.querySelector('.component-phone-input__clear-btn');
    var defaultCountry = String(root.getAttribute('data-default-country') || 'US').toUpperCase();
    var defaultOption = getAreaOptionByCode(defaultCountry) || AREA_OPTIONS[0];

    if (defaultOption && codeSpan) {
      codeSpan.textContent = defaultOption.dialCode;
      codeSpan.setAttribute('data-country', defaultOption.code);
    }

    if (defaultOption && flagSpan) {
      flagSpan.textContent = getCountryFlag(defaultOption.code);
      flagSpan.setAttribute('data-country', defaultOption.code);
    }

    var defaultDial = (defaultOption && defaultOption.dialCode) || getSelectedDialCode(root);

    // 构建下拉区号列表
    if (list && dropdown) {
      buildAreaList(list, defaultDial);
    }

    if (searchInput && list) {
      searchInput.addEventListener('input', function () {
        buildAreaList(list, getSelectedDialCode(root), searchInput.value || '');
      });
    }

    // 打开/关闭下拉
    if (countryBtn && dropdown) {
      countryBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = dropdown.style.display === 'block';
        dropdown.style.display = isOpen ? 'none' : 'block';
      });
    }

    // 选择区号
    if (dropdown && list && codeSpan) {
      list.addEventListener('click', function (e) {
        var item = e.target.closest('.component-phone-input__country-item');
        if (!item) return;

        var dial = item.getAttribute('data-dial-code') || '+1';
        var country = item.getAttribute('data-country') || 'US';

        // 更新展示的区号
        codeSpan.textContent = dial;
        codeSpan.setAttribute('data-country', country);

        if (flagSpan) {
          flagSpan.textContent = getCountryFlag(country);
          flagSpan.setAttribute('data-country', country);
        }

        // 更新选中态
        var all = list.querySelectorAll('.component-phone-input__country-item');
        all.forEach(function (el) { el.classList.remove('is-selected'); });
        item.classList.add('is-selected');

        if (searchInput) {
          searchInput.value = '';
        }
        dropdown.style.display = 'none';
      });
    }

    // 点击外部关闭下拉
    if (dropdown) {
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          dropdown.style.display = 'none';
        }
      });
    }

    // 仅允许输入数字
    if (input) {
      input.addEventListener('input', function () {
        var digits = input.value.replace(/\D/g, '');
        if (input.value !== digits) {
          input.value = digits;
        }

        // 输入时隐藏错误 & 更新清除按钮
        if (errorEl) {
          errorEl.style.display = 'none';
        }
        root.classList.remove('component-phone-input--error');
      });
    }

    // 清除按钮
    if (input && clearBtn) {
      var updateClear = function () {
        clearBtn.style.display = input.value ? 'inline-flex' : 'none';
      };

      input.addEventListener('input', updateClear);
      updateClear();

      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        input.focus();
        updateClear();
        if (errorEl) {
          errorEl.style.display = 'none';
        }
        root.classList.remove('component-phone-input--error');
      });
    }

    // 失焦时做验证
    function runValidation() {
      if (!input) return true;
      var dial = getSelectedDialCode(root);
      var result = validatePhoneByDialCode(dial, input.value || '');

      if (!result.isValid) {
        root.classList.add('component-phone-input--error');
        input.classList.add('component-phone-input__field--error');
        if (errorEl) {
          errorEl.textContent = result.message || 'Please enter a correct phone number';
          errorEl.style.display = 'block';
        }
      } else {
        root.classList.remove('component-phone-input--error');
        input.classList.remove('component-phone-input__field--error');
        if (errorEl) {
          errorEl.style.display = 'none';
        }
      }

      return result.isValid;
    }

    if (input) {
      input.addEventListener('blur', runValidation);
    }

    // 表单提交时校验
    var form = root.closest('form');
    if (form && input) {
      form.addEventListener('submit', function (e) {
        if (!runValidation()) {
          e.preventDefault();
          e.stopPropagation();
          input.focus();
        }
      });
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-component="phone-input"]');
    nodes.forEach(initPhoneInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();


